// ----------------------------------------
// Andriy EXTRA STUFF
// ----------------------------------------

$(window).ready(function ($) {
  // == BOA (Buy on Amazon)
  function boa_setup() {
    let boa_container = $('#get-on-amazon');
    if (boa_container.length < 1) {
      return;
    }
    // Hide the standard "Add To Cart" / "Buy It Now" buttons
    let boa_AddToCartButton = $('form.product-form');
    if (boa_AddToCartButton.length > 0) {
      $(boa_AddToCartButton).addClass('boa-hide');
    }
    // Show the BOA button instead
    $(boa_container).removeClass('boa-hide');

    // BOA click handler
    $(boa_container).on('click', 'button.boa', function (event) {
      // can optionally report GA event etc. before handling the click.

      const urlToGo = $(this).data('url') || '';
      if (urlToGo) {
        event.preventDefault();
        window.location.assign(urlToGo);
      }
    });
  }

  boa_setup();
});
